import React from 'react';
export function SectionImageDouble() {
  return <section style={{
    background: '#ffffff',
    padding: 0,
    margin: 0
  }} data-id="element-123">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772538280/image_57_kgsetq.png" alt="Imagen informativa 1" className="w-full block" style={{
      display: 'block',
      margin: 0,
      padding: 0
    }} data-id="element-124" />
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772538358/hf_20260302_190651_55bf7ad9-1b99-4b36-bef0-e3b10541bd72_x2vyj5.jpg" alt="Imagen informativa 2" className="w-full block" style={{
      display: 'block',
      margin: 0,
      padding: 0
    }} data-id="element-125" />
    </section>;
}